import React from 'react';
import PropTypes from 'prop-types';
import FileUpload from 'components/Common/FileUpload';
import { ApiService } from 'services';

const WithholdingStatementUploader = ({
  statementType,
  statementFormat,
  onFileSending,
  onFileUploadCancel,
  onFileUploadSuccess,
  onFileUploadError,
}) => {
  const isStandard = statementFormat === 'standard';

  const acceptedFiles = isStandard
    ? 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, .xlsx'
    : 'application/pdf,.jpg,.png,.jpeg,.xlsx';

  const docCategory = isStandard
    ? 'withholdingstatement'
    : 'unknownwithholdingstatement';

  return (
    <div className="col-12">
      <FileUpload
        key={ `whd-upload-${ statementType || 'none' }-${ statementFormat || 'none' }` }
        defaultMessage="Drop the Statement to upload here"
        postUrl={ ApiService.getFileUploadUrl() }
        accessTokenName={ ApiService.getAccessTokenName() }
        acceptedFiles={ acceptedFiles }
        maxFilesize={ 5 }
        maxUploadFiles={ 1 }
        timeout={ 60000 }
        docCategory={ docCategory }
        docType={ statementType || '' }
        extraParams={ { statementFormat } }
        removeFileAfterUpload
        onFileSending={ onFileSending }
        onFileUploadCancel={ onFileUploadCancel }
        onFileUploadSuccess={ onFileUploadSuccess }
        onFileUploadError={ onFileUploadError }
      />
    </div>
  );
};

WithholdingStatementUploader.propTypes = {
  statementType: PropTypes.string,
  statementFormat: PropTypes.string.isRequired,
  onFileSending: PropTypes.func.isRequired,
  onFileUploadCancel: PropTypes.func.isRequired,
  onFileUploadSuccess: PropTypes.func.isRequired,
  onFileUploadError: PropTypes.func.isRequired,
};

WithholdingStatementUploader.defaultProps = {
  statementType: '',
};

export default WithholdingStatementUploader;
